import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <h2 className="section-title">Kontakt</h2>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <h3>Adresa</h3>
              <p>Čelakovského 501/6<br />500 02 Hradec Králové</p>
            </div>
            
            <div className="contact-item">
              <h3>Telefon</h3>
              <p><a href="tel:+420777821756">777 821 756</a></p>
            </div>
            
            <div className="contact-item">
              <h3>E-mail</h3>
              <p><a href="mailto:smrxa@smrxashop.cz">smrxa@smrxashop.cz</a></p>
            </div>
            
            <div className="contact-item">
              <h3>IČ</h3>
              <p>73979627</p>
            </div>
          </div>
          
          <div className="opening-hours">
            <h3>Otevírací doba</h3>
            <div className="hours-list">
              <div className="hours-item">
                <span className="day">Po – Pá:</span>
                <span className="time">13:00 – 18:00</span>
              </div>
              <div className="hours-item">
                <span className="day">(nebo po telefonické domluvě)</span>
              </div>
              <div className="hours-item">
                <span className="day">So – Ne:</span>
                <span className="time">Zavřeno</span>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-map">
          <h3>Kde nás najdete</h3>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps?q=Čelakovského+501/6,+500+02+Hradec+Králové&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa - Šmrxa Shop, Čelakovského 501/6, Hradec Králové"
            ></iframe>
          </div>
        </div>

        <div className="social-media">
          <h3>Sociální sítě</h3>
          <div className="social-links">
            <a 
              href="https://www.facebook.com/smrxashop" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Facebook"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <span>Facebook</span>
            </a>
            <a 
              href="https://www.instagram.com/smrxa_shop/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>Instagram</span>
            </a>
          </div>
        </div>

        <div className="legal-info">
          <p>
            V případě, že dojde mezi námi a spotřebitelem ke vzniku spotřebitelského sporu z kupní smlouvy nebo ze smlouvy o poskytování služeb, který se nepodaří vyřešit vzájemně dohodou, může spotřebitel podat návrh na mimosoudní řešení takového sporu určenému subjektu mimosoudního řešení spotřebitelských sporů, kterým je:
          </p>
          <p>
            <strong>Česká obchodní inspekce</strong><br />
            Ústřední inspektorát – oddělení ADR<br />
            Štěpánská 796/44, 110 01 Praha 1<br />
            e-mail: <a href="mailto:adr@coi.cz">adr@coi.cz</a><br />
            web: <a href="https://adr.coi.cz" target="_blank" rel="noopener noreferrer">adr.coi.cz</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;

